import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const pagesExplorer: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/pages-explorer`),
};

export default pagesExplorer;
